module.exports = __webpack_public_path__ + "img/chinesecompany197.f9673224.png";